import { h } from 'preact';
import * as BaseComp from 'base/bolt/boltApp.js';
import Store from 'store/store';
import { joinClasses } from 'utils/utils';
import s from 'base/bolt/boltApp.sss';

export default class BoltApp extends BaseComp.default {
	constructor(props) {
		super(props);
		this.onLoadingIconLoad = this.onLoadingIconLoad.bind(this);
		this.onUserInteraction = this.onUserInteraction.bind(this);
		this.keyAssetsToLoad = [
			'mainBg',
			'starVideo',
			'launchStarSound'
		];
	}

	componentDidMount() {
		super.componentDidMount?.();
		Store.on('KEY_ASSET_LOADED', (asset) => {
			if (this.keyAssetsToLoad.includes(asset)) {
				const index = this.keyAssetsToLoad.indexOf(asset);
				if (index > -1) {
					this.keyAssetsToLoad.splice(index, 1);
				}
				if (this.keyAssetsToLoad.length === 0) {
					this.setState({ allKeyAssetsLoaded: true });
				}
			}
		});
		document.addEventListener('click', this.onUserInteraction);
	}

	componentWillUnmount() {
		super.componentWillUnmount?.();
		document.removeEventListener('click', this.onUserInteraction);
	}

	onUserInteraction() {
		if (this.bricksLoaded) return;
		// Tie bricks videos to user gesture to allow play on scroll later
		let loadedBricks = [];
		[0, 1, 2].forEach((id) => {
			const brickVideo = document.getElementById(`bricks-video-${id}`);
			if (brickVideo) {
				brickVideo.load();
				loadedBricks.push(id);
			}
		});
		if (loadedBricks.length === 3) {
			this.bricksLoaded = true;
		}
	}

	onLoadingIconLoad() {
		this.setState({ loadingIconLoaded: true });
	}

	checkIfLoaded() {
		const { allKeyAssetsLoaded } = this.state;
		const base = super.checkIfLoaded?.();
		return base && allKeyAssetsLoaded;
	}

	renderLoadingOccluder() {
		const { loadingIconLoaded } = this.state;
		const imageRoot = this.state.appState?.appData?.urls?.roots?.image || '';
		return (
			<div class={s.loadingOccluder} onAnimationEnd={this.occluderRemoved} key="occluder">
				<img class={joinClasses(s.loadingIcon, loadingIconLoaded && s.show)} src={`${imageRoot}/favico.png`} onLoad={this.onLoadingIconLoad} />
			</div>
		);
	}

}
